module.exports = __webpack_public_path__ + "static/img/jizhong1.b6cbe49e.webp";